module.exports = __webpack_public_path__ + "static/contact-form-8a863565e4c3884b5c2972c55af0f29b.jpg";